import axios from 'axios';
import store from '../../../store/index';

export default {
	editAdmin(admin) {
		return axios.patch(`api/admins/${admin.id}`, admin, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	deleteAdmin(admin) {
		return axios.delete(`api/admins/${admin.id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	addAdmin(admin) {
		return axios.post('api/admins', admin, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	loadAdmin(id) {
		return axios.get(`/api/admins/${id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	getRoles() {
		return axios.get('/api/roles', {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
